var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCookiesBanner
    ? _c("div", { staticClass: "cookies-banner" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("home.cookies.we-respect-your-privacy")) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cookies-banner-inner" }, [
          _vm.showSettings
            ? _c(
                "div",
                { staticClass: "settings" },
                [
                  _c(
                    "md-switch",
                    {
                      attrs: { disabled: 1 },
                      model: {
                        value: _vm.state.essential_storage,
                        callback: function($$v) {
                          _vm.$set(_vm.state, "essential_storage", $$v)
                        },
                        expression: "state.essential_storage"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("home.cookies.essential-description")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-switch",
                    {
                      model: {
                        value: _vm.state.analytics_storage,
                        callback: function($$v) {
                          _vm.$set(_vm.state, "analytics_storage", $$v)
                        },
                        expression: "state.analytics_storage"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("home.cookies.analytics-description")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-switch",
                    {
                      model: {
                        value: _vm.state.ad_user_data,
                        callback: function($$v) {
                          _vm.$set(_vm.state, "ad_user_data", $$v)
                        },
                        expression: "state.ad_user_data"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("home.cookies.ad-user-description")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-switch",
                    {
                      model: {
                        value: _vm.state.ad_personalization,
                        callback: function($$v) {
                          _vm.$set(_vm.state, "ad_personalization", $$v)
                        },
                        expression: "state.ad_personalization"
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              "home.cookies.ad-personalization-description"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            : _c("span", {
                staticClass: "info",
                domProps: { innerHTML: _vm._s(_vm.$t("home.cookies-info")) }
              }),
          _vm._v(" "),
          _c("div", { staticClass: "cookies-choice-wrapper" }, [
            _vm.showSettings
              ? _c("div", { staticClass: "cookies-choice-row" }, [
                  _c(
                    "a",
                    {
                      staticClass: "cookies-choice cookies-choice-refuse",
                      on: { click: _vm.refuse }
                    },
                    [_vm._v(_vm._s(_vm.$t("home.cookies.refuse-all")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "cookies-choice cookies-choice-accept",
                      on: { click: _vm.accept }
                    },
                    [_vm._v(_vm._s(_vm.$t("home.cookies.accept-all")))]
                  )
                ])
              : _c("div", { staticClass: "cookies-choice-row" }, [
                  _c(
                    "a",
                    {
                      staticClass: "cookies-choice cookies-choice-refuse",
                      on: { click: _vm.refuse }
                    },
                    [_vm._v(_vm._s(_vm.$t("home.cookies.refuse")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "cookies-choice cookies-choice-accept",
                      attrs: { dusk: "accept-cookies-button" },
                      on: { click: _vm.accept }
                    },
                    [_vm._v(_vm._s(_vm.$t("home.cookies.accept")))]
                  )
                ]),
            _vm._v(" "),
            _vm.showSettings
              ? _c("div", { staticClass: "cookies-choice-row" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "cookies-choice cookies-choice-save-parameters",
                      on: { click: _vm.saveSettings }
                    },
                    [_vm._v(_vm._s(_vm.$t("home.cookies.save-preferences")))]
                  )
                ])
              : _c("div", { staticClass: "cookies-choice-row" }, [
                  _c(
                    "a",
                    {
                      staticClass: "cookies-choice cookies-choice-parameters",
                      on: {
                        click: function($event) {
                          _vm.showSettings = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("home.cookies.preferences")))]
                  )
                ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cdb0e14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cdb0e14","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CookiesInfo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0cdb0e14","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CookiesInfo.vue
// module chunks = 1 2 3